// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoOpenDialogController from "./auto_open_dialog_controller"
application.register("auto-open-dialog", AutoOpenDialogController)

import ConfirmDialogController from "./confirm_dialog_controller"
application.register("confirm-dialog", ConfirmDialogController)

import CountdownTimerController from "./countdown_timer_controller"
application.register("countdown-timer", CountdownTimerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IllustrationSlideshowController from "./illustration_slideshow_controller"
application.register("illustration-slideshow", IllustrationSlideshowController)

import LegalTabsController from "./legal_tabs_controller"
application.register("legal-tabs", LegalTabsController)

import ReminderController from "./reminder_controller"
application.register("reminder", ReminderController)

import StretchBgmController from "./stretch_bgm_controller"
application.register("stretch-bgm", StretchBgmController)

import StretchLogController from "./stretch_log_controller"
application.register("stretch-log", StretchLogController)

import StretchLogDialogController from "./stretch_log_dialog_controller"
application.register("stretch-log-dialog", StretchLogDialogController)
